import styled from "@emotion/styled";

import { Card as MuiCard, Grid, CardContent } from "@mui/material";
import { spacing } from "@mui/system";

import OlogaPageHeader from "../../components/misc/OlogaPageHeader";
import { useLocation } from "react-router-dom";
import WorldTourForm from "./WorldTourForm";

const Card = styled(MuiCard)(spacing);

function UpdateWorldTour() {
  const { state } = useLocation();
  return (
    <>
      <OlogaPageHeader
        title="Edit World Tour"
        items={[{ label: "World Tours", url: "/events/world-tours" }]}
      />

      <Grid container>
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <WorldTourForm
                tour={{
                  ...state.tour,
                }}
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
}

export default UpdateWorldTour;
